import React from 'react';
import { QuestionHeading, QuestionOptionsList, QuestionPreviewField } from './QuestionBlockShared';

function DropdownBlock({ block, position }) {
    const options = Array.isArray(block.options) ? block.options : [];

    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />
            <QuestionPreviewField>
                <select className="form-select form-select-sm" disabled defaultValue="">
                    <option value="">{block.placeholder || 'Select an option'}</option>
                    {options.map((option) => (
                        <option key={option.id} value={option.value}>
                            {option.text}
                        </option>
                    ))}
                </select>
            </QuestionPreviewField>
            <QuestionOptionsList block={block} control="dropdown" />
        </div>
    );
}

export default DropdownBlock;
